// extracted by mini-css-extract-plugin
export var cartContainer = "_i9-4";
export var gray = "_i9-1";
export var itemContainer = "_i9-2";
export var itemDetails = "_i9-3";
export var strong = "_i9-0";